// @flow

export const RECEIVED_MENUS: 'listo/menus/RECEIVED_MENUS' = 'listo/menus/RECEIVED_MENUS';
export const DEFAULT_HEADER_MENU: 'header_menu' = 'header_menu';
export const DEFAULT_FOOTER_MENU: 'footer_menu' = 'footer_menu';

export default null;
